import { Text } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const Subtitle = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralAlternative,
      fontFamily: theme.fontFamily.semiBold,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
    variants: {
      size: {
        default: {
          fontSize: theme.fontSizeThreepulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreepulse,
            theme.lineHeightMedium
          ),
        },
        xs: {
          fontSize: theme.fontSizeThreeandhalfpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreeandhalfpulse,
            theme.lineHeightMedium
          ),
        },
      },
      type: {
        interactive: {
          maxWidth: '90%',
        },
        title: {},
      },
    },
  }
})
